import React from 'react';

export default () => (
  <div>
    <h1>Not Found</h1>
  </div>
);
